<template>
  <v-card class="pa-4" outlined elevation="8">
    <!-- <v-card-title>
      <v-select
        :items="years"
        density="compact"
        label="Année"
        item-value="value"
        item-title="text"
        return-object
        single-line
        @update:modelValue="getStatisticsByYear"
        v-model="selectedYear"
      ></v-select>
    </v-card-title> -->
    <v-card-text>
      <span class="text-h5"> KPI Globaux </span>
      <v-row justify="center" align="center" class="mb-4 mt-1">
        <v-col
          v-for="(item, index) in statisticsSecondPart"
          :key="index"
          cols="6"
          md="3"
        >
          <statistics-card
            :toShow="item.value"
            :type="item.type"
            :text="item.text"
          ></statistics-card>
        </v-col>
      </v-row>
      <span class="text-h5 pb-3">
        Ventes en points {{ selectedYear.text }} (prix tarif)
      </span>
      <v-row justify="center" align="center" class="mb-4 mt-1">
        <v-col v-for="(item, index) in statistics" :key="index" cols="6" md="3">
          <statistics-card
            :toShow="item.value"
            :type="item.type"
            :text="item.text"
          ></statistics-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import StatisticsCard from "@/components/kpi/StatisticsCard.vue";
import contractYear from "@/mixins/contractYear";

export default {
  name: "StatisticKpi",
  mixins: [contractYear],
  components: {
    StatisticsCard,
  },
  data() {
    // Calcul temporaire de l'année contractuelle pour l'initialisation
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const initialYear = month === 1 && day <= 15 ? year - 1 : year;

    return {
      /**
       * Tableau des années disponibles pour la sélection.
       * Contient l'année contractuelle courante et l'année précédente.
       */
      years: [
        { text: String(initialYear), value: initialYear },
        { text: String(initialYear - 1), value: initialYear - 1 },
      ],
      /**
       * Année sélectionnée par défaut : année contractuelle courante.
       */
      selectedYear: {
        text: String(initialYear),
        value: initialYear,
      },
    };
  },
  methods: {
    getStatisticsByYear(value) {
      this.$store.commit("setOverlay", true);
      this.$store
        .dispatch("kpi/fetchStatistics", value.value)
        .then(() => {
          this.$store.commit("setOverlay", false);
        })
        .catch(() => {
          this.$store.commit("setOverlay", false);
        });
    },
  },
  props: {
    statistics: {
      type: Array,
      required: true,
    },
    statisticsSecondPart: {
      type: Array,
      required: true,
    },
  },
};
</script>
